import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--panel-switcher"
export default class extends Controller {
  static values = {
    nextPanelId: String,
  };

  connect() {}

  switch(e) {
    // e.preventDefault(); を行わないのは、onclickイベントで呼ばれる処理を実行したいため。
    // ただし、それで不都合がある場合は、e.preventDefault() を実行する／しないをvaluesで制御することを検討する

    this.element.classList.add("hidden");
    const nextPanel = document.getElementById(this.nextPanelIdValue);
    if (nextPanel) {
      nextPanel.classList.remove("hidden");
    }
  }
}
